import React from 'react';
import classNameBind from 'classnames/bind';
import Stack from '../Stack';
import Header from '../Header';
import styles from './ZeroState.module.css';

const bindClasses = classNameBind.bind(styles);

const ZeroState = ({ imageType, title, children, withBorder, withBackground, dataId }) => (
  <div
    className={bindClasses('wrapper', { withBorder, withBackground })}
    data-ppuc-id={dataId || 'ZeroState'}
  >
    {imageType && <div className={bindClasses('image', imageType)} />}
    <div className={bindClasses('content')}>
      <Stack vertical>
        {title && (
          <Stack.Item>
            <Header type="large">{title}</Header>
          </Stack.Item>
        )}
        <Stack.Item>
          {children}
        </Stack.Item>
      </Stack>
    </div>
  </div>
);

ZeroState.defaultProps = {
  imageType: '',
  title: '',
  withBorder: true,
  withBackground: true,
};

export default ZeroState;
